import { registerSW } from 'virtual:pwa-register';
import i18n from '@/i18n';

let lastUserPromptTimeStamp: number | null = null;
const thresholdForTimeBetweenPrompts = 600000; //in ms; equivalent to 10 minutes

/**
 * Check if last prompt is far enough in the past to show one again.
 * @param currentTime expected to be current time in ms as delivered by Date.now()
 * @returns true if enough time has passed since last prompt to show a prompt again or if no prompt has been shown before.
 */
const enoughTimePassedSinceLastPrompt = function (currentTime: number) {
  return elapsedTimeSincePromptOverThreshold(
    currentTime,
    lastUserPromptTimeStamp,
    thresholdForTimeBetweenPrompts
  );
};

//Prompt user for pwa/service worker update
const promptForUpdate = async function (): Promise<boolean> {
  const updateAccepted = confirm(i18n.global.t('pwaUpdatePrompt.message')); //TODO better prompt
  lastUserPromptTimeStamp = Date.now(); //Set new timestamp of user prompt
  return updateAccepted;
};

//For the prompt to reload the page/pwa when the app has been updated
const updateSW = registerSW({
  async onNeedRefresh() {
    console.log('onNeedRefresh');
    const updateAccepted = await promptForUpdate();
    if (updateAccepted) {
      console.log(
        'User consent obtained. Calling updateSW(true) from onNeedRefresh()'
      );

      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('onOfflineReady');
  },
});

/**
 * Method for checking if difference between given times is above certain threshold.
 * All params are time in ms as returned by Date.now().
 * @param currentTime current time in ms as returned by Date.now()
 * @param timeOfLastPrompt timestamp of last prompt for updating the pwa
 * @param threshold threshold to be passed
 * @returns true if timeOfLastPrompt is null or timeOfLastPrompt - currentTime >= threshold
 */
function elapsedTimeSincePromptOverThreshold(
  currentTime: number,
  timeOfLastPrompt: number | null,
  threshold: number
) {
  if (timeOfLastPrompt === null) {
    return true; //To timestamp for last prompt. Assume there has never been one.
  }

  const elapsedTime = currentTime - timeOfLastPrompt;

  return elapsedTime >= threshold;
}

export default { updateSW, promptForUpdate, enoughTimePassedSinceLastPrompt };
